<template>
  <div class="login-box">
    <div class="login-handle-box show-flex-box-c show-flex-center" 
         v-show="isShowLogin && !bindAccountStatus" 
         @click.self="colseLoginWin()">
      <div class="login-total show-flex-box-r show-flex-center" >
        <div class="login-all show-flex-box-c" v-if="!isShowUserAgreement && !isShowPrivacyPolicy">
          <!-- X图标 -->
          <em @click.self="colseLoginWin()"></em>
          <dl class="login-content show-flex-box-c">
            <dt class="select-login-way show-flex-box-r">
              <ul class="select-login-way-list show-flex-box-r">
                <li
                  class="select-login-way-item show-flex-box-c"
                  :class="{'selected-login-active': loginWayType == item.type}"
                  v-for="(item, index) in loginOptions"
                  :key="index"
                  @click="selectedLoginWay(item)"
                >
                  <span>{{item.title}}</span>
                  <em></em>
                </li>
              </ul>
              <span @click="goToRegister()">去注册</span>
            </dt>
            <dd class="account-box show-flex-box-c">
              <div class="account-content-info show-flex-box-c">
                <h3 class="show-flex-box-r" v-if="passwordQuestion && loginWayType == 'account'">
                  <em></em>
                  <span>{{showErrorText}}</span>
                </h3>
                <ul
                  class="account-content-password-input show-flex-box-c"
                  v-if="loginWayType == 'account'"
                >
                  <li class="show-flex-box-r">
                    <em></em>
                    <span class="show-flex-box-r">
                      <input
                        type="text"
                        placeholder="请输入手机/邮箱"
                        v-model="passwrodLoginFrom.account"
                        @blur="checkAccountFormat()"
                      />
                    </span>
                  </li>
                  <li class="show-flex-box-r">
                    <em></em>
                    <span class="show-flex-box-r">
                      <input type="password" placeholder="请输入密码" v-model="passwrodLoginFrom.password" />
                    </span>
                    <strong @click="openForgetPassword()">忘记密码？</strong>
                  </li>
                </ul>

                <ul
                  class="account-content-password-input message-login-input show-flex-box-c"
                  v-if="loginWayType == 'message'"
                >
                  <li class="show-flex-box-r">
                    <em></em>
                    <span class="show-flex-box-r">
                      <input type="text" placeholder="请输入手机号" v-model="messageLoginFrom.phone" />
                    </span>
                  </li>
                  <li class="show-flex-box-r">
                    <em></em>
                    <span class="show-flex-box-r">
                      <input type="text" placeholder="请输入验证码" v-model="messageLoginFrom.verifiyCode" />
                    </span>
                    <h3 class="show-flex-box-r" v-if="!countDown">
                      <em></em>
                      <strong @click="verifyCodeCountDown()">获取验证码</strong>
                    </h3>
                    <h4 class="show-flex-box-r" v-else>
                      <em></em>
                      <strong>{{remainCount}}s</strong>
                    </h4>
                  </li>
                </ul>

                <ul
                  class="account-content-password-input message-login-input email-login-input show-flex-box-c"
                  v-if="loginWayType == 'email'"
                >
                  <li class="show-flex-box-r">
                    <em></em>
                    <span class="show-flex-box-r">
                      <input type="text" placeholder="请输入邮箱" v-model="emailLoginFrom.email" />
                    </span>
                  </li>
                  <li class="show-flex-box-r">
                    <em></em>
                    <span class="show-flex-box-r">
                      <input type="text" placeholder="请输入验证码" v-model="emailLoginFrom.verifiyCode" />
                    </span>
                    <h3 class="show-flex-box-r" v-if="!emailCountDown">
                      <em></em>
                      <strong @click="verifyCodeCountDown()">获取验证码</strong>
                    </h3>
                    <h4 class="show-flex-box-r" v-else>
                      <em></em>
                      <strong>{{remainEmailCount}}s</strong>
                    </h4>
                  </li>
                </ul>
              </div>
              <h3 class="show-flex-box-r">
                <span>登录注册即同意</span>
                <em @click="openUserAgreementPop()">“用户协议”</em>
                <span>和</span>
                <em @click="openPrivacyPolicyPop()">“隐私协议”</em>
              </h3>
              <span class="show-flex-box-r">
                <span @click="clickToLogin()">登录</span>
              </span>
              <div class="select-three-login show-flex-box-r">
                <span>其他方式登录：</span>
                <ul class="show-flex-box-r">
                  <li
                    class="show-flex--box-r"
                    v-for="(item, index) in socialLoginOptions"
                    :key="index"
                    @click="openThirdLogin(item)"
                  >
                    <span class="show-flex-box-r">
                      <img :src="item.img_icon" />
                    </span>
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
        </div>
        <div class="user-agreement show-flex-box-c" v-if="isShowUserAgreement">
          <h3 class="show-flex-box-r show-flex-center">
            <em @click="closeUserAgreementPop()"></em>
            <span>用户协议</span>
          </h3>
          
          <div class="show-flex-box-c">
            <div>
              <div class="box-scrollbar-hidden" v-html="userAgreement"></div>
            </div>
            
          </div>
        </div> 
        <div class="user-agreement show-flex-box-c" v-if="isShowPrivacyPolicy">
          <h3 class="show-flex-box-r show-flex-center">
            <em @click="closePrivacyPolicyPop()"></em>
            <span>隐私政策</span>
          </h3>
          
          <div class="show-flex-box-c">
            <div>
              <div class="box-scrollbar-hidden" v-html="privacyPolicy"></div>
            </div>
      
          </div>
        </div>
      </div>
    </div>
    <div class="bind-phone show-flex-box-r">
      <bind-phone-pop
        ref="open_bind_phone_pop"
        :bindParams="bindParams"
        @open-set-password-pop="openSetPasswordPop"
        @popShowStatusChange="onPopShowStatusByPhonePop"
      ></bind-phone-pop>
    </div>
    <div class="change-password show-flex-box-r">
      <set-password ref="open_change_password_pop"
                    :hasPwd="hasPwd"
                    @popShowStatusChange="onPopShowStatusByPwdPop"
                    @updata-bind-success="setPasswordSuccess"
      ></set-password>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import regex from "@/filter/regex";
import { CountDown } from "@/../static/js/CountDown";
// import {LoginUser} from "@/model/login_user.js";
import bindPhonePop from "@/views/login/bind_phone";
import setPassword from "@/views/login/set_password";

export default {
  name: "login",
  data() {
    return {
      socialLoginOptions: [
        {
          type: "weixin",
          img_icon: require("../../assets/login/wechat_icon.png")
        },
        // {
        //   type: "weibo",
        //   img_icon: require("../../assets/login/weibo_icon.png")
        // },
        // {
        //   type: "qq",
        //   img_icon: require("../../assets/login/qq_icon.png")
        // }
      ],
      loginOptions: [
        {
          type: "account",
          title: "密码登录"
        },
        {
          type: "message",
          title: "短信登录"
        },
        {
          type: "email",
          title: "邮箱登录"
        }
      ],
      isShowLogin: false,
      loginLoading: false,
      loginWayType: "account",
      passwordQuestion: false,
      remainCount: 60,
      countDown: false,
      remainEmailCount: 60,
      emailCountDown: false,
      passwrodLoginFrom: {
        account: "",
        password: ""
      },
      messageLoginFrom: {
        phone: "",
        verifiyCode: ""
      },
      emailLoginFrom: {
        email: "",
        verifiyCode: ""
      },
      userAgreement: "",
      isShowUserAgreement: false,
      privacyPolicy:"",
      isShowPrivacyPolicy: false,
      showErrorText:"",
      // 绑定和设置密码 start
      loginType: "",
      bindAccountStatus: false,
      bindParams: {},
      WXCode:"",
      hasPwd: true
      // 绑定和设置密码 end
    };
  },
  // inject: ["reload"],
  created() {
    this.loginType = this.$route.query.loginType || "";
    this.checkIsThirdLogin();
  },
  components: {
    bindPhonePop,
    setPassword,
    listenToken: function() {
      return this.$store.state.token;
    }
  },
  mounted() {
     this.getUserAgreement();
     this.getUserPrivacyPolicy();
  },
  methods: {
    getUserAgreement: function() {
      var params = {
        code: "tv_platform_agreement"
      };

      this.$client
        .getDocumentDetail(params)
        .then(res => {
          this.userAgreement = res.data.content;
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.data.message,
            type: "error"
          });
        });
    },
    // 三方登录相关绑定 start
    onPopShowStatusByPhonePop: function(showStatus) {
      const type = showStatus.type;
      
      this.setLoginHandlePopShowStatus(false);

      switch (type) {
        case 'close':
    
        break;
        case 'backLogin':
          this.setLoginWinShowStatus(true);
        break;
      }
    },
    onPopShowStatusByPwdPop: function(showStatus) {
      const type = showStatus.type;

      switch (type) {
        case 'close':
          this.setLoginHandlePopShowStatus(false);
          this.checkBindPhonePopDom();
        break;
        case 'backBindPhone':
        
        break;
      }
    },
    setLoginHandlePopShowStatus: function(isShow) {
      this.bindAccountStatus = isShow;
    },
    checkIsThirdLogin: function() {
      if (this.loginType == "WX") {
        this.WXCode = this.$route.query.code || "";
        this.socialLogin();
        // this.bindAccountStatus = true;
        // this.WXCode = '031b98Ga1r2k9C03soHa1dH5Dx4b98Gq';
        // this.socialLogin();
      }
    },
    socialLogin: function() {
      var params = {
        type: "weixin",
        code: this.WXCode
      };

      this.$client
        .socialLogin(params)
        .then(res => {
          if (res.code == 200) {
            const curData = res.data || {};
            this.socialLoginByToken(curData);
          }
        })
        .catch(err => {
          this.$router.back(-1);
        });
    },
    socialLoginByToken: function(loginData) {
      const userToken = loginData.token;

      if (userToken) {
        this.loginSucceed(userToken);
      } else {
        const authUser = loginData.authUserInfo;
        this.bindParams.type = "weixin";
        this.bindParams.unionid = authUser.unionid;

        this.checkBindPhonePopDom();
      }
    },
    checkBindPhonePopDom: function(isShow) {
      if (!this.$refs.open_bind_phone_pop) {
        var _this = this;
        setTimeout(() => {
          _this.checkBindPhonePopDom();
        }, 300);
        return;
      }

      this.$refs.open_bind_phone_pop.colseLoginWin(isShow);
    },
    openSetPasswordPop: function(bln) {
      if (!this.$refs.open_change_password_pop) {
        var _this = this;
        setTimeout(() => {
          _this.openSetPasswordPop(bln);
        }, 300);
        return;
      }

      this.hasPwd = bln;
      this.$refs.open_change_password_pop.colseSetPasswordWin();
    },
    setPasswordSuccess: function() {
      this.checkBindPhonePopDom(false);
      this.setLoginHandlePopShowStatus(false);
      this.$router.push({ path: "/web/index" });

      window.location.reload();
    },
    // 三方登录相关绑定 end
    getUserPrivacyPolicy: function() {
      var params = {
        code: "tv_privacy_agreement"
      };

      this.$client
        .getDocumentDetail(params)
        .then(res => {
          this.privacyPolicy = res.data.content;
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.data.message,
            type: "error"
          });
        });
    },
    setLoginWinShowStatus: function(isShow) {
      this.isShowLogin = typeof(isShow) != "undefined" ? isShow : !this.isShowLogin;
    },
    colseLoginWin: function() {
      this.isShowLogin = !this.isShowLogin;
    },
    selectedLoginWay: function(item) {
      this.loginWayType = item.type;
    },

    initCountDown: function() {
      var _this = this;
      this.counter = new CountDown(60, function(cnt) {
        if (0 === cnt) {
          (_this.countDown = false), _this.counter && _this.counter.cancel();
        } else {
          _this.remainCount = cnt;
        }
      });
    },
    initEmailCountDown: function() {
      var _this = this;
      this.counter = new CountDown(60, function(cnt) {
        if (0 === cnt) {
          (_this.emailCountDown = false),
            _this.counter && _this.counter.cancel();
        } else {
          _this.remainEmailCount = cnt;
        }
      });
    },

    checkAccountFormat: function() {
      var status = true;
      if (
        this.loginWayType == "account" &&
        !regex.isEmpty(this.passwrodLoginFrom.account)
      ) {
        if (!regex.isPhoneNumber(this.passwrodLoginFrom.account)) {
          if (!regex.isEmail(this.passwrodLoginFrom.account)) {
            this.$message({
              showClose: true,
              message: "您输入的手机号/邮箱号格式不正确",
              type: "error"
            });
            return;
          }
          return;
        }
      }
      return status;
    },
    clickToLogin: function() {
      // this.passwordQuestion = true;
      var type = "";
      var account = "";
      var password = "";

      // *************************** 表单验证 *****************************
      if (this.loginWayType == "account") {
        if (regex.isEmpty(this.passwrodLoginFrom.account)) {
          this.$message({
            showClose: true,
            message: "请输入您的手机/邮箱",
            type: "error"
          });
          return;
        }
        if (!regex.isPhoneNumber(this.passwrodLoginFrom.account)) {
          if (!regex.isEmail(this.passwrodLoginFrom.account)) {
            this.$message({
              showClose: true,
              message: "您输入的手机/邮箱号格式不正确",
              type: "error"
            });
            return;
          }
        }
        if (regex.isEmpty(this.passwrodLoginFrom.password)) {
          this.$message({
            showClose: true,
            message: "请输入您的密码",
            type: "error"
          });
          return;
        }

        type = "password";
        account = this.passwrodLoginFrom.account;
        password = this.passwrodLoginFrom.password;
      } else if (this.loginWayType == "message") {
        if (regex.isEmpty(this.messageLoginFrom.phone)) {
          this.$message({
            showClose: true,
            message: "请输入您的手机号",
            type: "error"
          });
          return;
        }
        if (!regex.isPhoneNumber(this.messageLoginFrom.phone)) {
          this.$message({
            showClose: true,
            message: "您输入的手机号格式不正确",
            type: "error"
          });
          return;
        }
        if (regex.isEmpty(this.messageLoginFrom.verifiyCode)) {
          this.$message({
            showClose: true,
            message: "请输入您收到的验证码",
            type: "error"
          });
          return;
        }
        type = "verify_code";
        account = this.messageLoginFrom.phone;
        password = this.messageLoginFrom.verifiyCode;
      } else if (this.loginWayType == "email") {
        if (regex.isEmpty(this.emailLoginFrom.email)) {
          this.$message({
            showClose: true,
            message: "请输入您的邮箱号",
            type: "error"
          });
          return;
        }
        if (!regex.isEmail(this.emailLoginFrom.email)) {
          this.$message({
            showClose: true,
            message: "您输入的邮箱号格式不正确",
            type: "error"
          });
          return;
        }
        if (regex.isEmpty(this.emailLoginFrom.verifiyCode)) {
          this.$message({
            showClose: true,
            message: "请输入您收到的验证码",
            type: "error"
          });
          return;
        }
        type = "verify_code";
        account = this.emailLoginFrom.email;
        password = this.emailLoginFrom.verifiyCode;
      }
      // *************************** 表单验证 *****************************
      if (!this.loginLoading) {
        this.loginLoading = true;
        var params = {
          type: type,
          account: account,
          password: password
        };
        // alert(JSON.stringify(params))
        this.$client
          .userLogin(params)
          .then(res => {
            console.log(JSON.stringify(res));
            if (res.code == 200) {
              var userToken = res.data.token;
              var userObj = res.data.user;
              var userInfo = {
                showname: userObj.showname,
                avatar: userObj.avatar.o,
                birthday: userObj.birthday,
                gender: userObj.gender,
                province: userObj.province,
                province_name: userObj.province_name,
                city: userObj.city,
                city_name: userObj.city_name,
                county: userObj.county,
                county_name: userObj.county_name,
                wallet: userObj.wallet,
                easemob_user: userObj.easemob_user,
                email: userObj.email,
                phone: userObj.phone,
                has_password: userObj.has_password,
                has_pay_password: userObj.has_pay_password,
                is_vip: userObj.is_vip
              };
              this.loginSucceed(userToken, userInfo);
              this.$store.dispatch("reqUpdateUserInfo");
              this.resetForm();
              this.loginLoading = false;
            }
          })
          .catch(err => {
            var errMsg = err && err.data && err.data.message ? err.data.message : '登录失败';

            this.$message({
              showClose: true,
              message: errMsg,
              type: "error"
            });

            this.showErrorText = errMsg;
            this.loginLoading = false;
            this.passwordQuestion = true;
          });
      }
    },
    verifyCodeCountDown: function() {
      if (this.checkCanVerify()) {
        if (this.loginWayType == "message") {
          if (!this.countDown) {
            this.initCountDown();
          }
        } else {
          if (!this.emailCountDown) {
            this.initEmailCountDown();
          }
        }
        this.sendMessage();
      }
    },
    checkCanVerify: function() {
      var status = true;
      if (this.loginWayType == "message") {
        if (regex.isEmpty(this.messageLoginFrom.phone)) {
          this.$message({
            showClose: true,
            message: "请输入您的手机号",
            type: "error"
          });
          return false;
        }
        if (!regex.isPhoneNumber(this.messageLoginFrom.phone)) {
          this.$message({
            showClose: true,
            message: "您输入的手机号格式不正确",
            type: "error"
          });
          return false;
        }
      } else if (this.loginWayType == "email") {
        if (regex.isEmpty(this.emailLoginFrom.email)) {
          this.$message({
            showClose: true,
            message: "请输入您的邮箱",
            type: "error"
          });
          return false;
        }
        if (!regex.isEmail(this.emailLoginFrom.email)) {
          this.$message({
            showClose: true,
            message: "您输入的邮箱格式不正确",
            type: "error"
          });
          return false;
        }
      }
      return status;
    },
    sendMessage: function() {
      var params = {
        account:
          this.loginWayType == "message"
            ? this.messageLoginFrom.phone
            : this.emailLoginFrom.email,
        way: this.loginWayType == "message" ? "phone" : "email",
        type: "login"
      };
      // alert(JSON.stringify(params));
      this.$client
        .sendVerifyCode(params)
        .then(res => {
          console.log("验证码发送成功");
          console.log(res);
          if (this.loginWayType == "message") {
            this.countDown = true;
          } else {
            this.emailCountDown = true;
          }

          this.counter.start();
        })
        .catch(err => {
          this.counter && this.counter.cancel();
          this.emailCountDown = false;
          this.countDown = false;
          console.log("验证码发送失败");
          console.log(err);
          if (err.data && err.data.message) {
            this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          }
        });
    },
    loginSucceed: function(token, userInfo) {
      let saveTokenObj = {
        token: token
      };

      this.$store.commit("SET_TOKEN", saveTokenObj);
      this.$store.commit("GET_USER", userInfo);
      this.$store.commit("LOGIN", true); //登录成功后改变登录状态
      this.isShowLogin = false;
    },
    // 重置表单
    resetForm: function() {
      this.passwrodLoginFrom.account = "";
      this.passwrodLoginFrom.password = "";
      this.messageLoginFrom.phone = "";
      this.messageLoginFrom.verifiyCode = "";
      this.emailLoginFrom.email = "";
      this.emailLoginFrom.verifiyCode = "";
      this.passwordQuestion = false;
    },
    closeUserAgreementPop: function() {
      this.isShowUserAgreement = false;
    },
    openUserAgreementPop: function() {
      this.isShowUserAgreement = true;
    },
    closePrivacyPolicyPop: function() {
      this.isShowPrivacyPolicy = false
    },
    openPrivacyPolicyPop: function() {
      this.isShowPrivacyPolicy = true;
    },
    setLoginPopShowStatus: function() {
      if (!this.isShowLogin) {
        this.$store.dispatch("setLoginPopShowStatus", false);
      }
    },
    goToRegister: function() {
      this.$parent.$refs.register.colseRegisterWin();
      this.isShowLogin = false;
    },
    openForgetPassword: function() {
      this.$parent.$refs.findPassword.colseFindpasswordWin();
      this.isShowLogin = false;
    },
    openThirdLogin: function(item) {
      console.log(item)
      this.$emit("save-third-login-type", item.type);
      // this.$parent.$refs.thirdLogin.colseThirdLoginWin();
      this.isShowLogin = false;
    }
  },
  watch: {
    listenToken: function() {
      if (!this.listenToken) {
        this.isShowLogin = true;
      }
    },
    loginWayType: function() {
      this.resetForm();
    },
    isShowLogin: function() {
      this.resetForm();
      this.setLoginPopShowStatus();
      this.loginWayType = "account";
    }
  }
};
</script>
<style lang="less" scoped>
.login-box {
  .login-handle-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.4);
    .login-total {
      width: 560px;
      padding: 30px 0px 60px 0px;
      background: #ffffff;
      border-radius: 8px;
      position: absolute;
      .login-all {
        width: 506px;
        height: 100%;
        align-items: flex-end;
        padding-left: 22px;
        > em {
          display: block;
          width: 22px;
          height: 22px;
          background: url("../../assets/login/close_arrow_icon.png") no-repeat
            center center;
          background-size: 22px 22px;
          margin-bottom: 18px;
          flex-shrink: 0;
          cursor: pointer;
        }
        > dl {
          width: 100%;
          > dt {
            padding-right: 23px;
            align-items: flex-end;
            margin-bottom: 30px;
            > ul {
              width: 100%;
              align-items: center;
              > li {
                align-items: center;
                margin-right: 25px;
                cursor: pointer;
                > span {
                  font-size: 24px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 33px;
                  white-space: nowrap;
                  flex-shrink: 0;
                  margin-bottom: 5px;
                }
                // >em{
                //   width:35px;
                //   height:5px;
                //   background:#CB1309;
                //   border-radius:3px;
                // }
              }
              .selected-login-active {
                > span {
                  color: #333333;
                }
                > em {
                  width: 35px;
                  height: 5px;
                  background: #cb1309;
                  border-radius: 3px;
                }
              }
            }
            > span {
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 21px;
              white-space: nowrap;
              flex-shrink: 0;
              margin-bottom: 10px;
              cursor: pointer;
            }
          }
          .account-box {
            width: 100%;
            .account-content-info {
              padding-right: 23px;
              > h3 {
                width: 100%;
                height: 41px;
                background: rgba(203, 19, 9, 0.06);
                border-radius: 4px;
                border: 1px solid #cb1309;
                margin-bottom: 20px;
                align-items: center;
                > em {
                  width: 13px;
                  height: 13px;
                  display: block;
                  background: url(../../assets/login/alret_icon.png) no-repeat
                    center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                  margin-left: 20px;
                }
                > span {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #cb1309;
                  line-height: 17px;
                  margin-left: 5px;
                }
              }
              .account-content-password-input {
                width: 100%;
                > li {
                  padding: 0px 15px;
                  height: 60px;
                  background: #fafafa;
                  box-shadow: 3px 3px 3px 0px #f4f4f9;
                  border-radius: 4px;
                  border: 1px solid #eeeeef;
                  margin-bottom: 20px;
                  align-items: center;
                  cursor: pointer;
                  > em {
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/account_icon.png) no-repeat
                      center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                  > span {
                    flex-grow: 1;
                    margin-left: 20px;
                    align-items: center;
                    > input {
                      width: 100%;
                      height: 100%;
                      font-size: 16px;
                      font-family: PingFangSC-Medium, PingFang SC;
                      font-weight: 500;
                      color: #333333;
                      line-height: 22px;
                    }
                  }
                  > strong {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #cb1309;
                    line-height: 17px;
                    cursor: pointer;
                  }
                }
                > li:hover {
                  padding: 0px 15px;
                  height: 60px;
                  background: rgba(203, 19, 9, 0.04);
                  box-shadow: 3px 3px 3px 0px rgba(203, 19, 9, 0.1);
                  border-radius: 4px;
                  border: 1px solid rgba(203, 19, 9, 1);
                }
                > li:nth-child(2) {
                  > em {
                    flex-shrink: 0;
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/password_icon.png)
                      no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                }
              }
              .message-login-input {
                > li > em {
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/tel_icon.png) no-repeat
                    center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
                > li:nth-child(2) > em {
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/verify_icon.png) no-repeat
                    center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
                > li:nth-child(2) > h3 {
                  width: 80px;
                  padding-left: 15px;
                  height: 20px;
                  border-left: 1px #cb1309 solid;
                  flex-shrink: 0;
                  > em {
                    width: 15px;
                    height: 15px;
                    display: block;
                    background: url(../../assets/login/message_icon.png) no-repeat
                      center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                    margin-top: 3px;
                  }
                  > strong {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #cb1309;
                    line-height: 20px;
                    margin-left: 5px;
                    cursor: pointer;
                    flex-shrink: 0;
                    white-space: nowrap;
                  }
                }
                > li:nth-child(2) > h4 {
                  width: 60px;
                  padding-left: 35px;
                  height: 20px;
                  border-left: 1px #cb1309 solid;
                  flex-shrink: 0;
                  cursor: default;
                  > em {
                    width: 15px;
                    height: 15px;
                    display: block;
                    background: url(../../assets/login/gray_message_icon.png)
                      no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                    margin-top: 3px;
                  }
                  > strong {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #cccccc;
                    line-height: 20px;
                    margin-left: 5px;
                    flex-shrink: 0;
                    white-space: nowrap;
                  }
                }
              }
  
              .email-login-input {
                > li > em {
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/email_icon.png) no-repeat
                    center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
                // >li:nth-child(2)>em{
                //   width: 20px;
                //   height: 20px;
                //   display: block;
                //   background: url(../../assets/login/verify_icon.png) no-repeat center center;
                //   background-size: 100% 100%;
                //   flex-shrink: 0;
                // }
              }
            }
            > h3 {
              align-items: center;
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              line-height: 18px;
              margin-bottom: 30px;
              > span {
                color: #999999;
              }
              > em {
                color: #666666;
                cursor: pointer;
              }
              > em:hover {
                text-decoration: underline;
              }
            }
            > span {
              padding-right: 23px;
              margin-bottom: 25px;
              > span {
                cursor: pointer;
                width: 100%;
                height: 60px;
                background: #cb1309;
                box-shadow: 0px 2px 4px 0px #cb1309;
                border-radius: 4px;
                line-height: 60px;
                text-align: center;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
              }
            }
            .select-three-login {
              padding-right: 23px;
              justify-content: space-between;
              align-items: center;
              > span {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }
              > ul {
                align-items: center;
                > li {
                  width: 45px;
                  height: 45px;
                  margin-left: 25px;
                  cursor: pointer;
                  > span {
                    display: block;
                    width: 45px;
                    height: 45px;
                    border-radius: 50%;
                    > img {
                      display: block;
                      width: 45px;
                      height: 45px;
                      object-fit: cover;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .user-agreement{
        width: 506px;
        // height: 553px;
        // overflow: auto;
        overflow: hidden;
        >h3{
          width: 100%;
          position: relative;
          margin-bottom: 30px;
          >em{
            position: absolute;
            display: block;
            width: 33px;
            height: 33px;
            background: url("../../assets/login/left_arrow_icon.png") center center no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            left: 0;
            top: 0px;
          }
          >span{
            font-size:24px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(51,51,51,1);
          }
        }
        
        >div{
          width: 526px;
          height: 425px;
          overflow-y: scroll;
          overflow-x: hidden;
          >div{
            width: 506px;
            font-size: 16px;
            font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
            font-weight: 400;
            color: rgba(48, 41, 41, 1);
            line-height: 24px;
            // overflow-y: hidden;
            // .box-scrollbar-hidden{
            //   width: 526px;
            // }
          }
         
        }
  
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue